import React from 'react'
import CheckBox from '../ui/CheckBox.jsx';


const SelectTherapyAreas = (props) => {
  return <div className="">
        <div className="card-content">
          <div className="grid">
        { props.therapy_areas.map(area => <div key={area._id}>
          <CheckBox
            label={area.name}
            adminNote={area.adminNote}
            onClick={() => props.click(area)}
            on={props.checkedCond(area)}/>
          </div>
          )
        }
        </div>
      </div>
      {props.children}
  </div>
}

export default SelectTherapyAreas;



// WEBPACK FOOTER //
// ./src/components/admin/SelectTherapyAreas.jsx